module.exports = __webpack_public_path__ + "static/click-outside-f94837d45aef518f4b79ebc5404f6ef0.mp4";